module.exports = __webpack_public_path__ + "media/300_HC_2023_What_Is_Security_Awareness.08a113a8.mp4";